import { render, staticRenderFns } from "./ElementBonusTableColumn.vue?vue&type=template&id=26380375&scoped=true"
import script from "./ElementBonusTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementBonusTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementBonusTableColumn.vue?vue&type=style&index=0&id=26380375&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26380375",
  null
  
)

export default component.exports